module.exports = __webpack_public_path__ + "fonts/NeverMind-Regular.82b554e1.ttf";